export default __webpack_public_path__ + "static/media/samsung-logo.9b98824b.png";